import { useRef, useCallback } from 'react';

type Handler<T extends unknown[], U> = (...args: T) => U;

export function useLatestCallback<T extends unknown[], U>(
  handler: Handler<T, U>
): Handler<T, U> {
  const handlerRef = useRef<Handler<T, U>>(handler);
  handlerRef.current = handler;

  return useCallback((...args: T) => {
    return handlerRef.current(...args);
  }, []);
}
